/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/router';
import * as i2 from '../../../../../src/app/components/guest/guest.component';
import * as i3 from '../../../../../src/app/providers/auth.service';
const styles_GuestComponent:any[] = ([] as any[]);
export const RenderType_GuestComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_GuestComponent,data:{}});
export function View_GuestComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(212992,(null as any),0,i1.RouterOutlet,[i1.ChildrenOutletContexts,i0.ViewContainerRef,
          i0.ComponentFactoryResolver,[8,(null as any)],i0.ChangeDetectorRef],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_GuestComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'ng-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_GuestComponent_0,
      RenderType_GuestComponent)),i0.ɵdid(114688,(null as any),0,i2.GuestComponent,
      [i3.AuthService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const GuestComponentNgFactory:i0.ComponentFactory<i2.GuestComponent> = i0.ɵccf('ng-component',
    i2.GuestComponent,View_GuestComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2d1ZXN0L2d1ZXN0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL25vZGUvYXBwL3NyYy9hcHAvY29tcG9uZW50cy9ndWVzdC9ndWVzdC5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL25vZGUvYXBwL3NyYy9hcHAvY29tcG9uZW50cy9ndWVzdC9ndWVzdC5jb21wb25lbnQudHMuR3Vlc3RDb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2d1ZXN0L2d1ZXN0LmNvbXBvbmVudC50cy5HdWVzdENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD4iLCI8bmctY29tcG9uZW50PjwvbmctY29tcG9uZW50PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBO3NDQUFBO1VBQUE7SUFBQTs7OztvQkNBQTtNQUFBOytCQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/guest/guest.component.ngfactory.ts